export default __webpack_public_path__ + "static/media/dot-igaming.2f3bc742.svg";